/**
 * Query-key factory for tenant team-user mutations (RBAC FE — team row actions).
 *
 * One source of truth for the team-users list cache key so every mutation
 * (invite / role-change / reset-password / deactivate / reactivate / delete)
 * invalidates the exact query the Team page reads (invariant #7 — keep local
 * state consistent with the backend after every write).
 *
 * Mirrors saUserKeys.ts pattern.
 */

/** Cache key for the tenant team-users list: `['team', slug, 'users']`. */
export function teamUsersKey(slug: string) {
  return ["team", slug, "users"] as const;
}
